/* eslint-disable no-unused-expressions */
import React, { useEffect, useState } from "react";
import { HiDocumentAdd } from "react-icons/hi";
import { Link, useNavigate } from "react-router-dom";
import GlobalForm from "../../../components/globalForm/GlobalForm";
import Loading from "../../../components/shared/loading/Loading";
import { updateData } from "../../../hooks/update";
import useFetch from "../../../hooks/useFetch";
import { apiPath, clientSideUrl, RoutePath } from "../../../utility/Constant";

const HiringPartnersCreate = () => {
  const { homeApi } = apiPath;
  const { homePartners } = RoutePath;
  const navigate = useNavigate();

  const [homeSubsidariesData, homeSubsidariesLoading] = useFetch(homeApi);
  const [filteredData, setFilteredData] = useState({});

  useEffect(() => {
    setFilteredData(
      homeSubsidariesData?.filter(
        (item) => item.section_type === "hiring-partners"
      )[0]
    );
  }, [homeSubsidariesData]);

  const { banner_images, _id } = filteredData ?? {};

  const imagesData = [];
  [1]?.map((item, index) => {
    imagesData.push({
      label: `Banner Image ${index}`,
      type: "file",
      name: "",
      defaultValue: item,
    });
  });

  const data = [
    {
      elementType: "input",
      label: "Logo Name",
      type: "Text",
      name: "title",
      required: false,
    },
    {
      elementType: "input",
      label: "Website Link",
      type: "Text",
      name: "website",
      required: false,
    },
    {
      elementType: "file",
      label: "Logo Image",
      name: "url",
      multiple: false,
      fullCol: true,
      required: true,
    },
  ];

  const update = async (data) => {
    const { title, url, website, ...rest } = data;
    let addData = {
      banner_images: [
        {
          url: url,
          website: website,
          title: title,
        },
      ],
    };
    addData.banner_images.push(...banner_images);
    const res = await updateData(homeApi, addData, _id);
    if (res?.length > 0) {
      setTimeout(() => {
        window.location.href = "/" + homePartners;
      }, 600);
    }
  };

  return (
    <div className="bg-white p-5 shadow-md rounded-md border mt-5">
      <div className="md:pl-8 my-4">
        <h1 className="font-oswald font-bold text-xl md:text-2xl  uppercase">
          <HiDocumentAdd className="inline w-8 h-8 mb-1" /> ADD NEW HIRING
          PARTNERS
        </h1>
      </div>
      <GlobalForm data={data} update={update} />
    </div>
  );
};

export default HiringPartnersCreate;
